import { APP_BASE_URL, USE_APP_SIGNUP } from './featureFlags'

const TRACKED_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ref', 'promo'] as const

export type TrackedParamKey = (typeof TRACKED_PARAMS)[number]

export type TrackedParams = Partial<Record<TrackedParamKey, string>>

export interface AppSignupOptions {
  plan?: string
  params?: TrackedParams
}

const buildSearch = (plan: string | undefined, params: TrackedParams | undefined): string => {
  const search = new URLSearchParams()
  if (plan) search.set('plan', plan)
  if (params) {
    for (const key of TRACKED_PARAMS) {
      const value = params[key]
      if (value) search.set(key, value)
    }
  }
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}

export function appSignupUrl(options: AppSignupOptions = {}): string {
  const { plan, params } = options
  const search = buildSearch(plan, params)
  return USE_APP_SIGNUP ? `${APP_BASE_URL}/signup${search}` : `/sign-up${search}`
}

export interface AppSignupLink {
  href: string
  external: boolean
}

export function appSignupLink(options: AppSignupOptions = {}): AppSignupLink {
  return { href: appSignupUrl(options), external: USE_APP_SIGNUP }
}

export function pickTrackedParams(input: URLSearchParams | Record<string, string | undefined>): TrackedParams {
  const out: TrackedParams = {}
  const get = (key: string): string | undefined => {
    if (input instanceof URLSearchParams) return input.get(key) ?? undefined
    return input[key]
  }
  for (const key of TRACKED_PARAMS) {
    const value = get(key)
    if (value) out[key] = value
  }
  return out
}
